import React, { useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { useDelayedHover } from "hooks/discovery";
import { documentBy, PLACEMENTS } from "constants/discovery";
import ActionButtons from "layout/discovery/ActionButtons";
import { setByContentHoveredTerm } from "slices/discovery/discoverySlice";
import { compareStringsCaseInsensitive } from "utils";

const ContentTerm = ({ legend, bold = false }) => {
  const dispatch = useDispatch();
  const termRef = useRef();

  const docBy = useSelector((state) => state.discovery.config.documentBy);
  const themes = useSelector((state) => state.discovery.themes);
  const checkedItems = themes?.filter(
    (theme) => theme.checked && theme.NounPhrase !== undefined
  );
  const byContentHoveredTerm = useSelector(
    (state) => state.discovery.config.byContentHoveredTerm
  );

  const { hovered, handleMouseOver, handleMouseOut } = useDelayedHover({
    onMouseOver: () => {
      dispatch(setByContentHoveredTerm(legend));
    },
    onMouseOut: () => {
      dispatch(setByContentHoveredTerm(null));
    },
  });

  const getTerms = () => {
    let terms = checkedItems.map((term) => term.NounPhrase);

    // remove duplicates
    terms = new Set(terms);
    terms = Array.from(terms);

    return terms;
  };

  return (
    <span
      ref={termRef}
      className={clsx("discovery__content_term", {
        bold,
        highlighted: compareStringsCaseInsensitive(
          legend,
          byContentHoveredTerm
        ),
      })}
      data-testid="discovery-content-term"
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {parse(legend)}
      {hovered && (
        <ActionButtons
          term={legend}
          terms={docBy === documentBy.theme ? getTerms() : [legend]}
          placement={PLACEMENTS.RIGHT}
          parentRef={termRef}
          alignBottom
        />
      )}
    </span>
  );
};

ContentTerm.propTypes = {
  legend: PropTypes.string.isRequired,
  bold: PropTypes.bool,
};

export default React.memo(ContentTerm);
